/** Canonical weekday keys for opening_times objects (lowercase, API-style). */
export const OPENING_TIMES_WEEKDAY_ORDER = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
] as const;

export type OpeningTimesWeekday = (typeof OPENING_TIMES_WEEKDAY_ORDER)[number];

const WEEKDAY_SET = new Set<string>(OPENING_TIMES_WEEKDAY_ORDER);

export function isOpeningTimesWeekdayKey(key: string): boolean {
  return WEEKDAY_SET.has(key.trim().toLowerCase());
}

export function findOpeningTimesWeekdayKey(
  openingTimes: Record<string, unknown>,
  canonicalDay: string,
): string | undefined {
  const lower = canonicalDay.toLowerCase();
  for (const k of Object.keys(openingTimes)) {
    if (k.trim().toLowerCase() === lower) {
      return k;
    }
  }
  return undefined;
}
